<template>
  <div :class="$style.visibility">
    <IconButton
      :class="$style.button"
      data-test-id="HeaderItemProductTour__button"
      hasNoBackground
      icon="discover"
      :text="title"
      type="secondary"
      @click="handleLaunchProductTour"
    />
  </div>
</template>

<script>
import { IconButton } from '@jumpcloud/ui-components';
import { mapActions, mapState } from 'vuex';
import { productTourLabels } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ProductTourMixin from 'client/components/ProductTour/ProductTourMixin';
import ProductTourSteps from 'client/components/ProductTour/ProductTourSteps';
import Util from 'client/util/Util';

const onboardingModule = 'OnboardingModule';

export default {
  name: 'HeaderItemProductTour',

  EventHelper,
  ProductTourSteps,

  components: {
    IconButton,
  },

  mixins: [ProductTourMixin],

  data() {
    return {
      title: 'Product Tour',
    };
  },

  computed: {
    ...mapState(onboardingModule, [
      'productTourStepIndex',
    ]),
  },

  methods: {
    ...mapActions(onboardingModule, [
      'setShowProductTour',
    ]),

    handleLaunchProductTour() {
      this.$options.EventHelper.triggerProductTourLaunchButtonClicked({
        location: productTourLabels.mainHeaderLocation,
        step: this.productTourStepIndex,
      });

      if (this.productTourStepIndex > 0) {
        this.setShowProductTour(true);
        // Start from the last viewed step
        Util.redirect(this.$options.ProductTourSteps[this.productTourStepIndex].navPanelLink.href);
      } else {
        // otherwise start from beginning modal
        this.openModal();
      }
    },
  },
};
</script>

<style scoped module>
@value (max-width-large) from '~css/breakpoints.css';

.button {
  --icon-button-spacing: var(--jc-spacer-small);
}

/* Legacy vue-test-utils - class needs to exist outside of @media */
.visibility {
  display: block;
}

/* Visibility based NavPanel collapse for mobile/tablet */
@media (max-width: max-width-large) {
  .visibility {
    display: none;
  }
}
</style>
